<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div v-for="(entry, index) in forumentries" class="row mt-2">
      <div class="col-9 px-2">
        <a style="color:inherit" v-bind:href="forumpageurl + '?threadid=' + entry.ThreadId">{{entry.ThreadName}}</a> ({{entry.Replies}})
      </div>
      <div class="col-3 px-2 text-right">
        {{entry.UserAbbreviation}}
      </div>
    </div>

  </div>
</template>

<script>

  import moment from 'moment'

  var forumentries = [];
  var forumpageurl = "/home/en-us/forum";

  export default {
    name: "discuss-miniview",

    components: {
      
    },
    props: {
      forumid: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        forumentries,
        date: new Date(),
        momentDate: moment(this.date),
        forumpageurl

      };
    },
    methods: {
      async loadEntries(date) {

        var requestContent = {
          page: 0,
        };
      //var stringPayload = JSON.stringify(requestContent);
      //SimplePost("/api/Threads/v1/View", stringPayload, onSuccess, onError);

       
        try {
          var url = '/api/Threads/v1/View';
          this.$http.post(url, requestContent).then(async response => {
            this.forumentries = response.data.Threads;
          })
        }
        catch (err) {
        }
        
      },
      
      getId() {
        return this._uid;
      },
     
    },
    watch: {
    },
    mounted() {
      this.loadEntries(new Date());

      var rootUrl = location.pathname;
      var arr = rootUrl.split("/");
      if (rootUrl.endsWith('/')) {
        arr.pop();
      }
      arr.pop(); // remove the actual page we are in;
      rootUrl = arr.join("/");

      this.forumpageurl = rootUrl + "/forum";
    }
  };
</script>

<style scoped>

 
</style>




// WEBPACK FOOTER //
// src/components/discuss/discuss-miniview.vue